// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialDeliverables_root__2rCjT","submitButton":"SocialDeliverables_submitButton__1jlG2"};